export default __webpack_public_path__ + "img/dc8d1db45803d4fc91e2c199001c0db4.svg";